export default __webpack_public_path__ + "static/media/edit-answer.44d17b2b.svg";